import react from "react";
import { Select } from "antd";

const LocationFilter = ({ locationOptions, locationSearch, handleLocationChange }) => {
    return (
        <Select
            value={locationSearch || ""}
            onChange={(e) => handleLocationChange(e)}
            className="me-2"
            style={{ width: 200 }}
            showSearch
            filterOption={(input, option) => {
                // Fix 5: Better filter logic
                return (option?.children ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
            }}
            allowClear
        >
            {locationOptions.map((location) => (
                <Select.Option key={location.id} value={location.id}>{location.name}</Select.Option>
            ))}
        </Select>
    )
};

export default LocationFilter;